import { makeStyles } from '@material-ui/core/styles';

export default makeStyles(() => ({
  root: {
    width: '94%',
    padding: '3% 3%',
    margin: 'auto',
  },
  loader: {
    color: '#DF0C36',
    position: 'fixed',
    left: '50%',
    top: '50%',
  },
  appBar: {
    height: '35px',
    background: '#fafafa',
    position: 'relative',
    borderBottom: '3px solid #DF0C36',
    marginTop: '16px',
    zIndex: 0,
  },
  buttonGroup: {
    height: '32px',
    boxShadow: 'none',
  },
  selectedTab: {
    textTransform: 'none',
    fontFamily: 'Helvetica Neue LT Std',
    fontStyle: 'normal',
    fontWeight: '500',
    fontSize: '14px',
    color: '#FFFFFF',
    lineHeight: '20px',
    background: '#DF0C36',
    width: 'fit-content',
    borderRadius: 0,
    '&:hover': {
      backgroundColor: '#DF0C36',
    },
  },
  button: {
    backgroundColor: 'transparent',
    '&:hover': {
      backgroundColor: 'transparent',
    },
  },
  selectedButton: {
    fontFamily: 'Helvetica Neue LT Std',
    fontStyle: 'normal',
    fontWeight: '500',
    fontSize: '14px',
    lineHeight: '20px',
    marginTop: '10px',
    color: '#DF0C36',
    textTransform: 'initial',
    '&:hover': {
      textDecoration: 'underline',
    },
  },
  endBarButton: {
    fontFamily: 'Helvetica Neue LT Std',
    fontStyle: 'normal',
    fontWeight: '500',
    fontSize: '14px',
    lineHeight: '20px',
    marginTop: '10px',
    color: '#666666',
    textTransform: 'initial',
    '&:hover': {
      textDecoration: 'underline',
    },
  },
  contentPaper: {
    height: '150px',
    width: '100%',
  },
  description: {
    flexDirection: 'row',
    alignItems: 'center',
    padding: '18px 48px',
    position: 'relative',
    width: '80%',
    background: '#FAFAFA',
    borderRadius: '2px',
    flex: 'none',
    order: 0,
    top: 30,
    flexGrow: 1,
    margin: '0 auto',
    fontFamily: 'Arial',
    fontStyle: 'normal',
    fontWeight: 'normal',
    fontSize: '14px',
    lineHeight: '20px',
    color: '#666666',
  },
}));
